
import { DependencyLifeTime, Injectable } from "@miracledevs/paradigm-web-di";
import { ContextCollection } from "../../../contexts/DependencyContext";
import { ConfigurationApiClient } from "../clients/ConfigurationApiClient";
import { IDataSource } from "./models/IDataSource";

@Injectable({ collection: ContextCollection, lifeTime: DependencyLifeTime.Singleton })
export class DataSourceService
{
	private readonly url: string;

	constructor(private readonly apiClient: ConfigurationApiClient)
    {
        this.url = "datasource";
    }

    async getById(id: number): Promise<IDataSource>
    {
        return await this.apiClient.get<IDataSource>(`${this.url}/${id}`);
    }

    async getByCodes(codes: string[]): Promise<IDataSource[]>
    {
        return await this.apiClient.post<IDataSource[]>(`${this.url}/bycodes`,{},JSON.stringify(codes));
    }

    async getByIds(ids: number[]): Promise<IDataSource[]>
    {
        return await this.apiClient.post<IDataSource[]>(`${this.url}/byids`,{},JSON.stringify(ids));
    }

    async getAll(): Promise<IDataSource[]>
    {
        return await this.apiClient.get<IDataSource[]>(`${this.url}/all`);
    }
}
